// Editable copy + flags for the homepage newsletter signup section
// (src/components/home/Newsletter.jsx). Change wording here, not in JSX.
export const NEWSLETTER_COPY = {
  eyebrow: "Stay in the loop",
  subtext: "New arrivals, price drops, and restocks — electronics, fashion, and more — straight to your inbox.",
  // Kenya/M-Pesa-flavoured variant — swap in via NEWSLETTER_FLAGS.market === "KE"
  subtextKE: "New arrivals, price drops, and restocks — electronics, fashion, and more — straight to your inbox.",
  emailPlaceholder: "Your email address",
  subscribeLabel: "Keep me posted",
  whatsappToggleLabel: "Get deals on WhatsApp too",
  whatsappPlaceholder: "e.g. 07XX XXX XXX",
  successMessage: "You're in — check your inbox.",
};

export const NEWSLETTER_FLAGS = {
  market: "KE",            // "KE" swaps in the M-Pesa-flavoured subtext
  enableWhatsApp: false,   // show the WhatsApp opt-in toggle
};
